module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/index.js
// module id = 5Pd1
// module chunks = 15